<template>
  <div class="main-app">
    <div class="rb-pravaler">
      <CloseComponent
        @click="close"
        top="-18px"
        right="-7px"
        size="12px"
        type="minimize"
      />
      <RbLoader />
      <RBToast />
      <RbTab
        :header="header"
        primary
      >
        <CourseFormComponent v-if="stepStore().getStep() === 'course'" />
        <SimulationFormComponent v-if="stepStore().getStep() === 'simulation'" />
        <StudentFormComponent v-if="stepStore().getStep() === 'student'" />
        <ComplementaryFormComponent v-if="stepStore().getStep() === 'complementary'" />
        <GuarantorFormComponent v-if="stepStore().getStep() === 'guarantor'" />
        <PasswordFormComponent v-if="stepStore().getStep() === 'password'" />
        <FeedbackFormComponent v-if="stepStore().getStep() === 'feedback'" />
        <template #bottom>
          <div class="bottom">
            <RbButton
              rounded
              :text="appConfig[stepStore().getStep()].back"
              @click="stepStore().previouStep"
              v-if="appConfig[stepStore().getStep()].back"
            />
            <RbButton
              form="rb-form"
              type="submit"
              :text="appConfig[stepStore().getStep()].next"
              primary
              rounded
              v-if="appConfig[stepStore().getStep()].next"
            />
          </div>
        </template>
      </RbTab>
    </div>
  </div>
</template>

<script setup lang="ts">
import { appStore, stepStore } from '@/store/app';
import type { IConfig } from './forms/interface/IConfig';
import CourseFormComponent from '@/components/forms/CourseFormComponent.vue';
import RbTab from './standards/RbTab.vue';
import RbButton from './standards/RbButton.vue';
import RbLoader from './standards/RbLoader.vue';
import SimulationFormComponent from './forms/SimulationFormComponent.vue';
import StudentFormComponent from './forms/StudentFormComponent.vue';
import ComplementaryFormComponent from './forms/ComplementaryFormComponent.vue';
import GuarantorFormComponent from './forms/GuarantorFormComponent.vue';
import PasswordFormComponent from './forms/PasswordFormComponent.vue';
import FeedbackFormComponent from './forms/FeedbackFormComponent.vue';
import RBToast from './standards/RBToast.vue';
import CloseComponent from './CloseComponent.vue';

const config = appStore().getConfig() as IConfig;
const header = ['Simulação'];
const emits = defineEmits(['close']);

function close(event) {
  event.stopPropagation();
  emits('close');
}

const appConfig: any = {
  course: {
    next: config.visual.first_form_button_text
  },
  simulation: {
    next: 'Continuar',
    back: 'Voltar'
  },
  student: {
    next: 'Continuar',
    back: 'Voltar'
  },
  complementary: {
    next: 'Continuar',
    back: 'Voltar'
  },
  guarantor: {
    next: 'Continuar',
    back: 'Voltar'
  },
  password: {
    next: 'Continuar',
    back: 'Voltar'
  },
  feedback: {}
};
</script>

<style lang="scss" scoped>
div.main-app {
  position: absolute;
  z-index: 99999999;
  width: 85vw;
  max-width: 357px;
  max-height: 85vh;
  border-radius: 4px;
  background-color: white;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 12px;

  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.12),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14),
    0px 2px 1px 0px rgba(0, 0, 0, 0.2);

  .rb-pravaler {
    position: relative;
    height: 100%;
    overflow: hidden;

    .bottom {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding: 20px 0;
    }
  }
}
</style>